<template>
  <template v-if="ancestors.length > 0">
    <ParentSelectorV2
      v-for="(ancestor, index) of ancestors"
      :key="index"
      :model-class="ancestor.modelClass"
      :required="ancestor.requiredForFilter"
      :is-form="isForm"
    />
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { TransientBaseObjectType } from '@/models/core/base'

import ParentSelectorV2 from './ParentSelectorV2.vue'

interface Props {
  modelClass: TransientBaseObjectType
  isForm?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  modelClass: null,
  isForm: false,
})

const ancestors = computed(() => {
  return props.modelClass.ancestors || []
})
</script>

<style lang="scss" scoped></style>
